import { render, staticRenderFns } from "./reviewTable.vue?vue&type=template&id=6b60c7ac&scoped=true"
import script from "./reviewTable.vue?vue&type=script&lang=js"
export * from "./reviewTable.vue?vue&type=script&lang=js"
import style0 from "./reviewTable.vue?vue&type=style&index=0&id=6b60c7ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b60c7ac",
  null
  
)

export default component.exports